module.exports = __webpack_public_path__ + "static/media/personal-data.f9f08ba5.pdf";